import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AumicoCoreProvider } from '@modeso/aumico-lib-core-fe';
import { Observable, finalize, shareReplay } from 'rxjs';
import { CreateShareDto } from '../dtos/createShare.dto';
import { GetShareDto } from '../dtos/getShare.dto';
import { ShareInformationDTO } from '../dtos/shareInformation.dto';
import { RoutesUtil } from '../utils/routes.util';

@Injectable({
    providedIn: 'root',
})
export class AumicoAnnualReportSharesService {
    constructor(
        private readonly http: HttpClient,
        private readonly coreProvider: AumicoCoreProvider,
        private readonly routesUtil: RoutesUtil,
    ) {}
    getCurrentActiveUserSharedAnnualReports$(): Observable<GetShareDto[]> {
        const url = this.routesUtil.getCurrentActiveUserSharedAnnualReportsUrl();
        return this.http.get<GetShareDto[]>(url);
    }

    declineSharedAnnualReport$(id: string): Observable<void> {
        const url = this.routesUtil.declineCurrentActiveUserSharedAnnualReportsUrl(id);
        this.coreProvider.dispatchBlockingRequest('declineSharedAnnualReport$');
        return this.http
            .patch<void>(url, undefined)
            .pipe(finalize(() => this.coreProvider.dispatchBlockingRequestEnd('declineSharedAnnualReport$')));
    }

    acceptSharedAnnualReport$(id: string): Observable<void> {
        const url = this.routesUtil.acceptCurrentActiveUserSharedAnnualReportsUrl(id);
        this.coreProvider.dispatchBlockingRequest('acceptSharedAnnualReport$');
        return this.http
            .patch<void>(url, undefined)
            .pipe(finalize(() => this.coreProvider.dispatchBlockingRequestEnd('acceptSharedAnnualReport$')));
    }

    shareAnnualReports$(payload: CreateShareDto): Observable<any> {
        const url = this.routesUtil.shareAnnualReport();
        this.coreProvider.dispatchBlockingRequest('shareAnnualReports$');
        return this.http
            .post<void>(url, payload)
            .pipe(finalize(() => this.coreProvider.dispatchBlockingRequestEnd('shareAnnualReports$')));
    }

    getShareInformation$(annualReportMetaInformationId: string): Observable<ShareInformationDTO> {
        const url = this.routesUtil.getShareInformation(annualReportMetaInformationId);
        this.coreProvider.dispatchBlockingRequest('getShareInformation$');
        return this.http.get<ShareInformationDTO>(url).pipe(
            shareReplay(),
            finalize(() => this.coreProvider.dispatchBlockingRequestEnd('getShareInformation$')),
        );
    }
}
